export const lenisStore = { instance: null };

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisStore.instance) {
    lenisStore.instance.scrollTo(el, { offset: 0, duration: 1.6 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
